export default class LanguageSelector {
  constructor() {
    this.form = document.querySelector('.js-lang-select');
    this.select = this.form.querySelector('select[name="language"]');
    this.submit = this.form.querySelector('.js-lang-submit');

    if(this.submit) {
      // We need a useless submit button for ADA purposes
      this.submit.addEventListener('click', (event) => {
        event.preventDefault();
      });
    }

    if(this.select) {
      this.select.addEventListener('change', (event) => {
        if(event.target.value) {
          window.location.href = event.target.value;
        }
      });
    }
  }
}
